import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { GLViewRow } from "../glViewTypes";
import { getGLTableMeta } from "./glCellHelpers";
import { JournalLineSourceCell } from "./JournalLineCells";

export const GLSourceCell = React.memo(function GLSourceCell({
    row,
    table,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;

    if (rowKind !== "transaction" || !transaction) {
        return <ViewTableCell />;
    }

    const onSourceClick = getGLTableMeta(table)?.callbacks?.onSourceClick;

    return (
        <JournalLineSourceCell
            source={transaction.source}
            isRecurring={!!transaction.recurringRuleId}
            onClick={
                onSourceClick ? () => onSourceClick(transaction) : undefined
            }
        />
    );
});
